import { useEffect, useState } from 'react';

function useTooltip(localStorageKey) {
  const [showTooltip, setShowTooltip] = useState(false);

  const renderTooltip = () => {
    if (!window?.localStorage?.getItem(localStorageKey)) {
      localStorage.setItem(localStorageKey, JSON.stringify(true));
      setShowTooltip(true);
    } else {
      setShowTooltip(JSON.parse(window?.localStorage?.getItem(localStorageKey)))
    }
  };

  useEffect(() => {
    renderTooltip();
  }, []);


  const onCloseTooltip = () => {
    localStorage.setItem(localStorageKey, JSON.stringify(false));
    setShowTooltip(false);
  };

  return {
    showTooltip,
    onCloseTooltip,
  };
}

export default useTooltip;
